import { Link } from "react-router-dom";
import { getArticlesByCategory, getCategory, themeOf } from "@/utils/content";

const spotlights = ["local", "campus"];

export default function CategorySpotlight() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto flex max-w-6xl flex-col gap-12 px-4 md:gap-16 md:px-8">
        {spotlights.map((slug, index) => {
          const category = getCategory(slug);
          if (!category) return null;
          const theme = themeOf(slug);
          const list = getArticlesByCategory(slug).slice(0, 3);
          const reversed = index % 2 === 1;

          return (
            <div
              key={slug}
              className={`grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12 ${
                reversed ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div className="relative h-64 w-full overflow-hidden rounded-lg md:h-80">
                <img
                  src={category.cover}
                  alt={`${category.name}专题配图`}
                  title={`${category.name} - 511爆料专题`}
                  className="h-full w-full object-top object-cover"
                />
                <span className={`absolute bottom-4 left-4 rounded-md px-3 py-1.5 text-xs font-semibold ${theme.solid}`}>
                  {category.updated}
                </span>
              </div>

              <div>
                <p className={`flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] ${theme.text}`}>
                  <span className={`inline-block h-px w-6 ${theme.dot}`} />
                  分类专题
                </p>
                <h3 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{category.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{category.desc}</p>

                <ul className="mt-6 flex flex-col divide-y divide-background-200 border-y border-background-200">
                  {list.map((item) => (
                    <li key={item.id}>
                      <Link
                        to={`/article/${item.id}`}
                        className="group flex items-center justify-between gap-4 py-3"
                      >
                        <span className="line-clamp-1 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-600">
                          {item.title}
                        </span>
                        <i className="ri-arrow-right-up-line shrink-0 text-foreground-400 transition-colors group-hover:text-primary-500" />
                      </Link>
                    </li>
                  ))}
                </ul>

                <Link
                  to={`/category/${slug}`}
                  className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  进入 {category.short} 分类
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}